import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-site-logo-winter',
  templateUrl: './site-logo-winter.component.html',
  styleUrls: ['./site-logo-winter.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class SiteLogoWinterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
